import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeedNotificationService } from 'app/services/feed-notifications.service';
import { interval } from 'rxjs';

import { NotificationSeenEvent } from '../notifications-card/notifications-card.component';

@Component({
	selector: 'notifications-menu',
	templateUrl: './notifications-menu.component.html',
	styleUrls: ['./notifications-menu.component.scss'],
})
export class NotificationsMenuComponent implements OnInit, OnDestroy {
	isNotificationsCardOpen = false;
	newNotificationsCounter = 0;
	interval;
	constructor(private feedNotificationService: FeedNotificationService) {}

	ngOnInit(): void {
		this.getUnseenNotifications();
		this.interval = interval(300000).subscribe(() =>
			this.getUnseenNotifications()
		);
	}

	ngOnDestroy(): void {
		this.interval.unsubscribe();
	}

	toggleNotificationsCard(currentState: boolean) {
		this.isNotificationsCardOpen = currentState;
	}

	onNotificationSeen(event: NotificationSeenEvent): void {
		this.newNotificationsCounter -= event.total;
	}

	private getUnseenNotifications(): void {
		this.feedNotificationService
			.getUnseenNotifications()
			.subscribe((response) => (this.newNotificationsCounter = response.total));
	}
}
